export enum CredentialType {
    Email = "email",
    Anonymous = "anonymous",
}
